import { observer } from "mobx-react-lite";
import React from "react";
import ContactPageButton from "../ContactPage/ContactPageButton";
import LogoModel from "../LogoModel";
import i18n from "../Translations";

const Header = () => (
  <div id="Header">
    <div id="HeaderContainer">
      <LogoModel />
      <div className={`header-phone-block ${i18n.language}`}>
        <ContactPageButton />
      </div>
    </div>
  </div>
);

export default observer(Header);
